<template>
  <div class="container-fluid my-3 record" style="min-height:50vh">
    <div class="row">
      <div>
        <h5>考場說明:</h5>
        <ul>
          <li>考場開放時間為進入考場時間，在開放時間內進入後均可完整作答試卷，直到交卷為止。</li>
          <li>進入考場後未完成的交卷不得離開，若因網路斷線可重新登入後續考試。</li>
          <li>作答方式為單據逐句錄音，請逐句點選做答，系統不會自動進入下一句。</li>
          <li>每個單元題組全部句子完成後才能點選計算成績送出。</li>
          <li>計算成績送出後不可更改。</li>
        </ul>
      </div>
    </div>
    <div>
      <div class="col-12" style="min-height:40vh">
        <div>
          <table class="rwd-table mt-3">
          <thead>
            <tr>
              <th colspan="7" class="main-title">考場列表</th>
            </tr>
          </thead>
            <tbody>
              <tr>
                <th>考場名稱</th>
                <th>開始時間</th>
                <th>結束時間</th>
                <th>老師姓名</th>
                <th>成績</th>
                <th>備註</th>
                <th>狀態</th>
              </tr>
              <tr v-for="(item, index) in roomList" :key="index">
                <td data-th="考場名稱">
                  {{item.name}}
                </td>
                <td data-th="開始時間">
                  {{item.begin_at}}
                </td>
                <td data-th="結束時間">
                  {{item.end_at}}
                </td>
                <td data-th="老師姓名">
                  {{item.creator.name}}
                </td>
                <td data-th="成績">
                  {{item.score!==null ? item.score : '尚未作答'}}
                </td>
                <td data-th="備註">
                  <div class="ellipsis">
                    {{item.note!==null ? item.note : '無'}}
                  </div>
                </td>
                <td data-th="成績">
                  <div v-if="item.score === null  && now < item.end_at">
                    <button v-if="now>=item.begin_at" type="button" class="btn btn-success" @click="goExam(item)">開始測驗</button>
                    <button v-else type="button" class="btn btn-success" disabled >尚未開放</button>
                  </div>
                  <button v-else type="button" class="btn btn-success" @click="goExamDetail(item)">查看詳細</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div>
        <pagination v-if="pageCount>1" class="m-auto pt-4" :current="pageIndex" :total="pageCount" v-on:page="toPage"/>
      </div>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
import Pagination from '@/components/Pagination.vue'
import moment from 'moment';
import 'vue2-datepicker/index.css';
import api from '../store/api';
import 'balloon-css';
import { mapState } from 'vuex'
export default {
  name: 'Exam-hall',
  data () {
    return {
      pageCount: 10,
      pageIndex: 1,
      roomList: [],
      oralList: [],
      infoActive: false
    }
  },
  components: {
    Pagination
    // DatePicker
  },
  computed: {
    ...mapState({ group_id: state => state.auth.groupId }),
    now () {
      return moment().format("YYYY-MM-DD HH:mm");
    }
  },
  mounted () {
    this.getRoomList()
  },
  methods: {
    goPage (el) {
      this.currentPage = el
      this.getPersonalData()
      let isGroup = el==='All'? false: true
      this.getLeaderBoardList(isGroup)
    },
    async getRoomList () {
      const { data } = await api.get(`liveabc/rooms?group_id=${this.group_id}&page=${this.pageIndex}&pageSize=10`)
      this.roomList = data.data
      this.pageCount = data.pageCount
      this.pageIndex = data.pageIndex
    },
    async getOralList (roomId) {
      const { data } = await api.get(`liveabc/rooms/${roomId}/oral_contents`)
      this.oralList = data.data
    },
    goExam (el) {
      this.$router.push({ name: 'Oral-exam', params:{ examId: el.id, repeatable: el.is_repeatable ? 1 : 0 }})
    },
    goExamDetail (el) {
      this.$router.push({ name: 'Exam-detail', params:{ examId: el.id }})
    },
    toPage (toPage) {
      this.pageIndex = toPage
      this.getRoomList()
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../assets/styles/color.scss";
//@import "~balloon-css/src/balloon";
.record {
  text-align: left;
  .layout {
    min-height: 50vh;
  }
}
  .ellipsis {
    max-width: 100px;
    overflow:hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .info {
    border-radius: 50px;
    background-color: #000;
    margin: auto 5px;
    width: 16px;
    height: 16px;
    color: #fff;
    font-size: .8rem;
  }
  .info-content {
    padding: 10px;
    right: 0px;
    top: 25px;
    position: absolute;
    width: 200px;
    height: 100px;
    color: #ffffff;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 500;
  }
  .hide {
    display: none;
  }
  table {
    border-collapse: collapse;
    width: 100%;
    overflow: auto;
  }
  th {
    overflow:hidden;
    color: #fff;
    text-align: center !important;
    padding: 8px;
  }
  tr:nth-child(even){
    background-color:#e8e8e8 !important;
  }
  /*表格中的奇數對 tr*/
  tr:nth-child(odd){
    background-color:#d8d8d8 !important;
  }
  td {
    font-weight: bold;
    // background-color: rgb(230, 230, 230);
    border: 4px solid #fff;
    text-align: center !important;
    padding: 8px;
  }

  .title-box {
    margin-bottom: 20px;
    border-top: #aaa solid 1px;
    border-bottom: #aaa solid 1px;
    padding: 10px 0;
    .title {
      color: #aaa;
      margin: 0 50px 0 0;
      cursor: pointer;
    }
    .active {
      color: black;
    }
  }
  .rwd-table {
  margin: auto;
  min-width: 300px;
  max-width: 100%;
  border-collapse: collapse;
}

.rwd-table tr:first-child {
  border-top: none;
  background: $table-gray !important;
  color: #fff;
}

.rwd-table tr {
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  background-color: #f5f9fc;
}

.rwd-table tr:nth-child(odd):not(:first-child) {
  background-color: #ebf3f9;
}

.rwd-table tbody th {
  display: none;
}

.rwd-table td {
  display: block;
}

.rwd-table td:first-child {
  margin-top: .5em;
}

.rwd-table td:last-child {
  margin-bottom: .5em;
}

.rwd-table td:before {
  content: attr(data-th) ": ";
  font-weight: bold;
  width: 120px;
  display: inline-block;
  color: #000;
}

.rwd-table th,
.rwd-table td {
  text-align: left;
}

.rwd-table tr {
  border-color: #bfbfbf;
}

.rwd-table th,
.rwd-table td {
  padding: .5em 1em;
}
.main-title {
  background: rgb(24, 97, 255);
  border: none !important;
}

@media screen and (max-width: 601px) {
  .rwd-table tr:nth-child(2) {
    border-top: none;
  }
  .rwd-td {
    display: block !important;
    background-color: #04a2d6;
  }
  td {
    border: 1px solid #ccc;
  }
}
.lesson-box {
  width: 80%;
}
.group-box {
  width: 20%;
}
.box {
  margin: 5px;
  padding: 10px;
  background-color: #044ed6;
  color: #fff;
}
@media screen and (min-width: 600px) {
  .rwd-table tr:hover:not(:first-child) {
    background-color: #d8e7f3;
  }
  .rwd-table td:before {
    display: none;
  }
  .rwd-table tbody th,
  .rwd-table td {
    display: table-cell;
    padding: .25em .5em;
  }
  .rwd-table th:first-child,
  .rwd-table td:first-child {
    padding-left: 0;
  }
  .rwd-table th:last-child,
  .rwd-table td:last-child {
    padding-right: 0;
  }
  .rwd-table th,
  .rwd-table td {
    // padding: 1em !important;
  }
}
</style>
